var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    display: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "edit",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.19665 0.136684C9.01441 -0.0455612 8.71893 -0.0455612 8.53668 0.136684L6.06668 2.60669L11.3933 7.93332L13.8633 5.46332C14.0456 5.28107 14.0456 4.98559 13.8633 4.80335L9.19665 0.136684Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.67337L5.40671 3.26665L10.7333 8.59329L5.32663 14H0.466667C0.208934 14 0 13.7911 0 13.5333V8.67337Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46667 14H14V13.0667H7.46667V14Z"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "cancel",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2428 6.34311L6.34334 16.2426C5.95281 16.6331 5.95281 17.2663 6.34334 17.6568C6.73386 18.0473 7.36703 18.0473 7.75755 17.6568L17.657 7.75732C18.0476 7.36679 18.0476 6.73363 17.657 6.34311C17.2665 5.95258 16.6334 5.95258 16.2428 6.34311Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6569 16.2426L7.7574 6.34309C7.36688 5.95257 6.73371 5.95257 6.34319 6.34309C5.95266 6.73362 5.95266 7.36678 6.34319 7.75731L16.2427 17.6568C16.6332 18.0473 17.2664 18.0473 17.6569 17.6568C18.0474 17.2663 18.0474 16.6331 17.6569 16.2426Z",
    fill: "#333333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSprite);
export default __webpack_public_path__ + "static/media/icon-sprite.9571d146da17101a0e9b086a83410cb1.svg";
export { ForwardRef as ReactComponent };